import "./MsTeamsIntegration.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import IntegrationBenefits from "./sections/IntegrationBenefits";
import DirectRoutingVsOperatorConnectComparison from "./sections/DirectRoutingVsOperatorConnectComparison";
import MsTeamsDialpadShowcase from "./sections/MsTeamsDialpadShowcase";
import CtaGetStarted from "./sections/CtaGetStarted";
import Footer from "@/reusable_sections/Footer";
export default function MsTeamsIntegrationPage() {
  return <div>
      <Header />
      <HeroSection />
      <IntegrationBenefits />
      <DirectRoutingVsOperatorConnectComparison />
      <MsTeamsDialpadShowcase />
      <CtaGetStarted />
      <Footer />
    </div>;
}